import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JobSearchComponent } from './app-job-home/app-job-search.component';
import { JobSearchResultsComponent } from './app-job-search-results/app-job-search-results.component';
import { JobPageComponent } from './app-job-detail-page/app-job-page.component';
import { JobForSchoolsComponent } from './app-job-for-schools/app-job-for-schools.component';
import { JobForTeachersComponent } from './app-job-for-teachers/app-job-for-teachers.component';


const routes: Routes = [
  { path: '', component: JobSearchComponent , pathMatch: 'full' },
  { path: 'home', component: JobSearchComponent , pathMatch: 'full' },
  { path: 'for-teachers', component: JobForTeachersComponent , pathMatch: 'full' },
  { path: 'for-schools', component: JobForSchoolsComponent, pathMatch: 'full' },
  { path: 'result', component: JobSearchResultsComponent, pathMatch: 'full' },
  { path: 'detail', component: JobPageComponent, pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JobRoutingModule { }
